import React from "react";
import SpecialDaysTemplate from "../../components/templates/specialDays/specialDaysTemplate";

const SpecialDays: React.FC = () => {
  return <SpecialDaysTemplate />;
};

export default SpecialDays;
